import { getAction, postAction } from '@/api/api'

const managerCompanyName = (params) =>
  getAction('/manager/system/companyInfo', params)

//管理员
const managerLogin = (params) => postAction('/manager/auth/login', params)
const managerLogout = (params) => postAction('/manager/auth/logout', params)
const managerRestPassword = (params) =>
  postAction('/manager/user/updatePwd', params)

// 公司管理
const managerCompanyAdd = (params) => postAction('/manager/company/add', params)
const managerCompanyUpdate = (params) =>
  postAction('/manager/company/update', params)
const managerCompanyList = (params) =>
  getAction('/manager/company/list', params)

// 权限管理
const managerAllCompanyList = (params) =>
  getAction('/manager/managers/allCompanyList', params)
const managerManagerCompanyList = (params) =>
  getAction('/manager/managers/getCompanyList', params)
const managerUpdateManagerCompany = (params) =>
  postAction('/manager/managers/update', params)

const managerStaffList = (params) => getAction('/manager/staff/list', params)
const managerStaffDetails = (params) =>
  getAction('/manager/staff/details', params)
const managerUpdateStaffDetails = (params) =>
  postAction('/manager/staff/updateInfo', params)
const managerAddStaffDetails = (params) =>
  postAction('/manager/staff/add', params)
const managerManagersList = (params) =>
  getAction('/manager/managers/list', params)
const managerAllAuthCode = (params) =>
  getAction('/manager/managers/allAuthCode', params)
const managerAuthorityList = (params) =>
  getAction('/manager/managers/getAuthorityList', params)
const managerupdateAuthority = (params) =>
  postAction('/manager/managers/updateAuthority', params)
const managerDeleteManager = (params) =>
  postAction('/manager/managers/ban', params)
const managerAddManager = (params) =>
  postAction('/manager/managers/add', params)
const managerUpdateExpandInfo = (params) =>
  postAction('/manager/staff/updateExpandInfo', params)
const managerStaffSalaryInfo = (params) =>
  getAction('/manager/staff/salaryInfo', params)
const managerSetSalaryInfo = (params) =>
  postAction('/manager/staff/setSalaryInfo', params)
const managerStaffSalaryList = (params) =>
  postAction('/manager/salaryReport/salaryInfoList', params)
const managerAddSalaryReport = (params) =>
  postAction('/manager/salaryReport/add', params)
const managerSalaryReportList = (params) =>
  getAction('/manager/salaryReport/list', params)
const managerDeleteSalaryReport = (params) =>
  postAction('/manager/salaryReport/remove', params)
const managerUpdateSalaryReport = (params) =>
  postAction('/manager/salaryReport/update', params)
const managerSalaryReportDetail = (params) =>
  getAction('/manager/salaryReport/reportDatalist', params)

const staffExpandKey = () => getAction('/manager/staffExpandKey/list')
const staffExpandKeyAdd = (params) =>
  postAction('/manager/staffExpandKey/add', params)
const staffExpandKeyUpdate = (params) =>
  postAction('/manager/staffExpandKey/update', params)

export {
  managerCompanyName,
  managerLogin,
  managerLogout,
  managerRestPassword,
  managerCompanyList,
  managerCompanyAdd,
  managerCompanyUpdate,
  managerAllCompanyList,
  managerManagerCompanyList,
  managerUpdateManagerCompany,
  managerStaffList,
  managerStaffDetails,
  managerUpdateStaffDetails,
  managerAddStaffDetails,
  staffExpandKey,
  staffExpandKeyAdd,
  staffExpandKeyUpdate,
  managerManagersList,
  managerAllAuthCode,
  managerAuthorityList,
  managerupdateAuthority,
  managerDeleteManager,
  managerAddManager,
  managerUpdateExpandInfo,
  managerStaffSalaryInfo,
  managerSetSalaryInfo,
  managerStaffSalaryList,
  managerAddSalaryReport,
  managerSalaryReportList,
  managerDeleteSalaryReport,
  managerUpdateSalaryReport,
  managerSalaryReportDetail,
}
